import React from 'react';

import PropTypes from 'prop-types';
import {CallMade} from '@material-ui/icons';
import {AppBar, Box, Grid} from '@material-ui/core';

import {MainContent} from 'layouts/commons';
import {EfeButtonPrimary} from 'components';
import {useHistory} from 'react-router-dom';
import {AppBarStyles} from 'assets/tss/commons';
import {nextStep} from 'commons/utils/Functions';
import {InferPropTypes} from 'commons/types/Types';

EfeSave.propTypes = {
    disabled: PropTypes.bool.isRequired,
    flow: PropTypes.any.isRequired,
    menu: PropTypes.any.isRequired,
    updateModuleStep: PropTypes.func.isRequired,
    secondaryButton: PropTypes.element,
    overrideHandler: PropTypes.func,
};

function EfeSave(props: InferPropTypes<typeof EfeSave.propTypes>) {
    const {disabled, flow, menu, updateModuleStep, secondaryButton, overrideHandler} = props;
    const history = useHistory();
    const classes = AppBarStyles();

    function handleSubmit() {
        updateModuleStep(false);
        const path = nextStep(flow, menu, true);
        history.push(path);
    }

    const SimpleSubmit = (
        <Box m={2}>
            <EfeButtonPrimary
                fullWidth
                onClick={overrideHandler ? overrideHandler : handleSubmit}
                type='submit'
                disabled={!disabled}
                endIcon={<CallMade />}>
                {'Guardar y continuar'}
            </EfeButtonPrimary>
        </Box>
    );

    const CompoundSubmit = (
        <Grid item xs={12}>
            <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                <Grid item xs={12}>
                    {secondaryButton}
                </Grid>
                <Grid item xs={12}>
                    {SimpleSubmit}
                </Grid>
            </Box>
        </Grid>
    );

    return (
        <AppBar position='fixed' color='primary' className={classes.appBar}>
            <MainContent>
                <Grid container direction='row' justifyContent='flex-start'>
                    {secondaryButton ? CompoundSubmit : SimpleSubmit}
                </Grid>
            </MainContent>
        </AppBar>
    );
}

export default EfeSave;
